import React from 'react';
import { FlaskConical, ShieldCheck, Zap, AlertTriangle, ExternalLink, Lock, Eye, Users } from 'lucide-react';

export default function LaunchpadPolicy() {
  return (
    <div className="max-w-4xl mx-auto space-y-12 animate-in slide-in-from-bottom-8 duration-700">
      <div className="text-center space-y-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 rounded-full border border-emerald-500/20 text-emerald-400 font-bungee text-[10px] uppercase tracking-widest">
          <FlaskConical size={14} />
          <span>Labs Program</span>
        </div>
        <h2 className="text-5xl md:text-6xl font-bungee text-emerald-400 uppercase tracking-tighter leading-none">FOUNDER SELL POLICY</h2>
        <p className="text-zinc-500 font-bungee text-sm uppercase tracking-widest">Transparency Commitments</p>
      </div>

      <div className="bg-zinc-900/50 border-4 border-emerald-500/10 rounded-[3rem] p-10 md:p-16 space-y-12">
        <section className="space-y-6">
          <h3 className="text-3xl font-bungee text-white uppercase tracking-tight border-l-4 border-emerald-500 pl-6">Founder Sell Policy Template</h3>
          <p className="text-zinc-400 font-bungee text-sm leading-relaxed">
            Every token launched through BrainRotBlast Labs must adhere to our strict founder sell policy. This ensures that the team's interests are aligned with the community's.
          </p>
          <div className="bg-black/40 p-8 rounded-[2rem] border border-emerald-500/10 space-y-6">
            <div className="flex items-center gap-4 text-emerald-400">
              <Lock size={20} />
              <h4 className="font-bungee text-lg uppercase">The Commitment</h4>
            </div>
            <ul className="space-y-4 text-xs text-zinc-500 font-bungee leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="text-emerald-500">•</span>
                <span>No team tokens will be sold within the first 24 hours of launch.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-emerald-500">•</span>
                <span>Team sell caps are set at 1% of total supply per 24-hour period.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-emerald-500">•</span>
                <span>All team wallets are public and tracked on this page.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-emerald-500">•</span>
                <span>Liquidity is locked for a minimum of 6 months.</span>
              </li>
            </ul>
          </div>
        </section>

        <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="p-8 bg-black/40 rounded-[2rem] border border-emerald-500/10 space-y-4">
            <div className="p-3 bg-emerald-500/10 rounded-xl border border-emerald-500/20 w-fit">
              <Eye size={24} className="text-emerald-400" />
            </div>
            <h4 className="text-xl font-bungee text-white uppercase">Public Wallets</h4>
            <p className="text-xs text-zinc-500 font-bungee leading-relaxed">
              We publish all team and treasury wallets. You can track our every move on the blockchain. No hidden wallets.
            </p>
          </div>
          <div className="p-8 bg-black/40 rounded-[2rem] border border-emerald-500/10 space-y-4">
            <div className="p-3 bg-emerald-500/10 rounded-xl border border-emerald-500/20 w-fit">
              <Users size={24} className="text-emerald-400" />
            </div>
            <h4 className="text-xl font-bungee text-white uppercase">Authority Revocation</h4>
            <p className="text-xs text-zinc-500 font-bungee leading-relaxed">
              Mint and freeze authority are revoked immediately upon launch to ensure the contract is immutable and fair.
            </p>
          </div>
        </section>

        <section className="p-8 bg-emerald-500/5 border-2 border-emerald-500/20 rounded-[2rem] space-y-6">
          <div className="flex items-center gap-3 text-emerald-400">
            <AlertTriangle size={24} />
            <h4 className="text-xl font-bungee uppercase">Transparency Commitments</h4>
          </div>
          <p className="text-xs text-emerald-100/60 font-bungee leading-relaxed">
            We believe that transparency is the only way to build trust in the meme-coin space. 
            By publishing our policies and wallets, we aim to set a new standard for fair launches.
          </p>
          <div className="pt-4">
            <button className="px-6 py-3 bg-emerald-500 text-black rounded-xl font-bungee text-xs uppercase shadow-lg hover:scale-105 transition-all">
              View Public Wallets
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
